import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, take, tap } from 'rxjs/operators';
import { StatusFromSVEntity } from '../entities/statusFromSV.entity';
import { State } from '../State';
import { getStatusFromSV } from '../State/selectors/status-from-sv.selectors';
import { StatusFromSVActionTypes } from '../State/actions/statusFromSV.actions';

@Injectable({
  providedIn: 'root'
})
export class StatusFromSVResolver implements Resolve<StatusFromSVEntity[]> {
  constructor(private store: Store<State>) {
  }

  resolve() {
    const value$ = this.store.select(getStatusFromSV);

    value$
      .pipe(
        filter(value => !value),
        take(1),
        tap(() => {
          if (localStorage.getItem('token') != null) {
            this.store.dispatch(StatusFromSVActionTypes.GetStatusFromSVRequest());
          }
        })
      )
      .subscribe();

    return value$.pipe(
      filter(value => !!value),
      take(1)
    );
  }
}
